import React, { useRef, useState, useEffect } from 'react';
import { FormattedHTMLMessage, useIntl } from 'gatsby-plugin-intl';
import { useStaticQuery, graphql } from 'gatsby';
import { css } from '@emotion/core';
import { mainColor } from '../../constants/colors';
import { Desktop, Tablet } from '../../constants/responsive';
import Pagination from '../Pagination';
import { useMount, useUpdateEffect, useSessionStorage } from 'react-use';
import { useAppContext } from '../../context/AppContext';

const topicToTag = {
  'market-insights': 'insight',
  'investing-101': 'investment101',
  'company-updates': 'news',
  'research-analytics': 'research_reports',
  'money-talks': 'money_talks',
};

const BlogList = ({ topic }) => {
  console.log(topic, 'topic+++++');
  const intl = useIntl();
  const data = useStaticQuery(graphql`
    query {
      allBlogPost {
        edges {
          node {
            id
            locale
            blog_id
            blog_url
            name
            title
            publish_date
            banner_image
            authors
            tags
            topics
          }
        }
      }
      allResearchReport {
        edges {
          node {
            id
            date
            press_image
            title_en
            title_zhans
            title_zhant
            upload_file_en
            upload_file_zhans
            upload_file_zhant
          }
        }
      }
    }
  `);
  const [selectedTag, setSelectedTag] = useSessionStorage(
    'blog-selsected-tag',
    topic ? topicToTag[topic] : ''
  );

  const [selectedPage, setSelectedPage] = useSessionStorage(
    'blog-selsected-page',
    1
  );
  if (!selectedTag) {
    console.log('setSelectedTag - all');
    setSelectedTag('all');
  }
  const { blogTopic } = useAppContext();
  const topicFilterRef = useRef(null);
  const [isClient, setClient] = useState(false);
  useMount(() => {
    setClient(true);
    if (topic) {
      window.scrollTo({
        top: topicFilterRef.current.offsetTop - 20,
        left: 0,
        behavior: 'smooth',
      });
    }
  });
  useUpdateEffect(() => {
    if (blogTopic) {
      setSelectedTag(topicToTag[blogTopic]);
      window.scrollTo({
        top: topicFilterRef.current.offsetTop - 20,
        left: 0,
        behavior: 'smooth',
      });
    }
  }, [blogTopic]);

  const paginationDom = useRef();
  /* 监听selectedPage的改变 */
  useUpdateEffect(() => {
    scrollToPagination();
  }, [selectedPage]);

  const scrollToPagination = () => {
    var view = window.innerHeight;
    var paginationTop = paginationDom.current.offsetTop;
    // 非手机类宽屏设备
    window.scrollTo(0, paginationTop - view + 150);
    // 手机类窄屏设备
    if (window.innerWidth < 768) {
      window.scrollTo(0, paginationTop - view + 200);
    }
  };

  const allResearchReports = data.allResearchReport.edges
    .map((node) => node.node)
    .map((report) => {
      const localeToLang = {
        en: 'en',
        'zh-cn': 'zhans',
        'zh-hk': 'zhant',
      };
      return {
        id: report.id,
        locale: intl.locale,
        link: report[`upload_file_${localeToLang[intl.locale]}`],
        title: report[`title_${localeToLang[intl.locale]}`],
        publish_date: report.date,
        banner_image: report.press_image,
        authors: '',
        tags: ['research_reports'],
        topics: '',
      };
    });

  const allBlogPosts = data.allBlogPost.edges
    .map((node) => node.node)
    .concat(allResearchReports)
    .filter((post) => post.locale === intl.locale)
    .filter((post) => {
      const tags = post.tags.map((tag) => tag.toLowerCase());
      return (
        tags.includes('insight') ||
        tags.includes('investment101') ||
        tags.includes('news') ||
        tags.includes('research_reports') ||
        tags.includes('money_talks')
      );
    })
    .filter(
      (post) =>
        selectedTag === 'all' ||
        post.tags.map((tag) => tag.toLowerCase()).includes(selectedTag)
    )
    .sort((a, b) => {
      if (a.publish_date < b.publish_date) {
        return 1;
      }
      if (a.publish_date > b.publish_date) {
        return -1;
      }
      return 0;
    });

  const maxPage = Math.ceil(allBlogPosts.length / 6);

  const tags = [
    'all',
    'insight',
    'investment101',
    'news',
    'research_reports',
    'money_talks',
  ];
  return (
    <>
      <div ref={topicFilterRef}>
        <h2
          css={css`
            margin-bottom: 20px;
            padding-bottom: 5px;
            border-bottom: 5px solid black;
          `}
        >
          {
            {
              en: 'Browse by Topics',
              'zh-cn': '主题分类',
              'zh-hk': '主題分類',
            }[intl.locale]
          }
        </h2>
        <div
          css={css`
            visibility: ${isClient ? 'visible' : 'hidden'};
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 20px;
            font-size: 12px;
            ${Tablet} {
              font-size: 16px;
            }
          `}
        >
          {tags.map((tag) => {
            const selected = tag === selectedTag;
            return (
              <div
                key={`${tag}-${isClient}`}
                css={css`
                  height: 40px;
                  border-radius: 40px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  background: #f2f2f2;
                  padding: 10px 20px;
                  margin-right: 20px;
                  margin-bottom: 20px;
                  font-weight: ${selected ? 'bold' : 'normal'};
                  color: ${selected ? mainColor : 'black'};
                  cursor: pointer;
                `}
                onClick={() => {
                  setSelectedTag(tag);
                  setSelectedPage(1);
                }}
              >
                <FormattedHTMLMessage id={`blog.${tag}`} />
              </div>
            );
          })}
        </div>
      </div>
      <div
        css={css`
          margin-top: 40px;
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
        `}
      >
        {allBlogPosts
          .filter((_post, index) => {
            return Math.ceil((index + 1) / 6) === selectedPage;
          })
          .map((post) => {
            const linkStyle = css`
              flex: 0 0 100%;
              ${Tablet} {
                flex: 0 0 45%;
              }
              ${Desktop} {
                flex: 0 0 30%;
              }
              margin-bottom: 40px;
            `;
            const imgStyle = css`
              border-radius: 10px;
              box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
              height: 100%;
              width: 100%;
              position: absolute;
              top: 0;
              left: 0;
            `;
            const titleStyle = css`
              margin-bottom: 5px;
              width: 100%;
            `;
            const authorDateStyle = css`
              margin-bottom: 5px;
              width: 100%;
            `;
            const topicsStyle = css`
              display: flex;
              flex-wrap: wrap;
              width: 100%;
            `;
            const tagStyle = css`
              height: 28px;
              border-radius: 28px;
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 12px 20px;
              font-size: 14px;
              color: ${mainColor};
              background: #f2f2f2;
              margin-right: 10px;
              margin-bottom: 10px;
            `;
            const isResearchReports = post.tags.includes('research_reports');
            return (
              <a
                key={post.id}
                css={linkStyle}
                href={
                  isResearchReports
                    ? post.link
                    : `/${intl.locale}/blog/${post.blog_id}/${post.blog_url}`
                }
                target='_blank'
              >
                <div
                  css={css`
                    position: relative;
                    width: 100%;
                    height: 171.44px; //限定显示图片的高度
                    padding-top: 52.35%;
                    margin-bottom: 15px;
                  `}
                >
                  <img
                    css={imgStyle}
                    src={`${post.banner_image}?x-oss-process=image/resize,m_fill,w_1456,h_762/quality,Q_70/format,jpg/interlace,1`}
                    alt={post.title}
                  />
                </div>
                <h3 css={titleStyle}>
                  <b>{post.title}</b>
                </h3>
                <h5 css={authorDateStyle}>
                  {isResearchReports
                    ? `${post.publish_date}`
                    : `${post.authors} / ${post.publish_date}`}
                </h5>
                <div css={topicsStyle}>
                  {[post.topics]
                    .filter((tag) => tag)
                    .map((tag) => {
                      return (
                        <div key={tag} css={tagStyle}>
                          #{tag.toLowerCase()}
                        </div>
                      );
                    })}
                </div>
              </a>
            );
          })}
        {new Array(6 - (allBlogPosts.length % 6)).fill(0).map((_val, index) => {
          return (
            <div
              key={index}
              css={css`
                flex: 0 0 100%;
                ${Tablet} {
                  flex: 0 0 45%;
                }
                ${Desktop} {
                  flex: 0 0 30%;
                }
              `}
            ></div>
          );
        })}
      </div>
      {allBlogPosts.length > 0 && (
        <Pagination
          ref={paginationDom}
          value={selectedPage}
          onChange={setSelectedPage}
          max={maxPage}
        />
      )}
    </>
  );
};

export default BlogList;
